/* eslint-disable operator-linebreak */
import CPUtils from '@src/slide/application/service/copy-paste/core/cp-utils';
import { SlideModelSdkTypeV3 } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { deepClone } from '@src/framework/frame-m/components/utils/object';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import {
    IDrawingShapeData, DataType, ISlideData,
    ILayoutData, SlideDataModel, STAddonMode, IConnectorData, IPageData,
    IPresentationDataModel,
    PresentationDataModel,
    ISlideDataModel,
    IShapeData,
    INoteSlideData,
} from '@tencent/slide-sdk-model';
import { ElementSdkDataModify } from '@src/slide/application/service/copy-paste/core/paste/element-sdk-data-modify';
import { transaction as sdkTransaction } from '@src/slide/domain/slide-app';
import { transaction as mobxTransaction } from 'mobx';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { ILayoutModel } from '@src/slide/domain/ui-model/element-modeles/Interface/layout-model.interface';
import {
    PresentationModelSdkTypeV3,
} from '@src/slide/domain/ui-model/element-modeles/Interface/presentation-model.interface';
import MasterLayoutUtils from '@src/slide/domain/ui-model/utils/master-layout-utils';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import {
    IMasterLayoutEditService,
} from '@src/slide/application/service/master-layout-edit-service/master-layout-edit-service.interface';
import StoreManager from '@src/slide/application/service/copy-paste/core/store-manager';
import ClearanceUtils from '@src/slide/domain/ui-model/utils/clearance-utils';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { IMasterModel } from '@src/slide/domain/ui-model/element-modeles/Interface/master-model.interface';
import { ISectionManager } from '@src/slide/application/service/section-manager/section-manager.interface';
import { IAddonManager } from '@src/slide/application/service/addon/addon-manager.interface';
import { SlideSdkDataModify } from '@src/slide/application/service/copy-paste/core/paste/slide-sdk-data-modify';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import isEmpty from 'lodash/isEmpty';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import cloneDeep from 'lodash/cloneDeep';
import { ICopiedSlideData, IClipboardData, ISdkData, CopyDataVersion, CopyElementType } from '@src/slide/domain/ui-model/element-modeles/property/copy/copy-model/paste-special.interface';
import PasteSpecialUtils from '@src/slide/application/service/copy-paste/core/paste/paste-special/paste-special-utils';
import { pasteSpecialEventBus } from '@src/slide/application/service/copy-paste/core/paste/paste-special/event-bus';
import { IResourceMapData } from '@tencent/slide-sdk-model/src/data/resource-map-data';
import { PanelType } from '@src/framework/frame-pc/components/paste-special-panel/interface';
import { CommonTips, CommonTipsType, i18n } from '../../../edit-extension/edit-extension-export';
import { ENABLE_PASTE_SPECIAL } from '@src/slide/infrastructure/module/dependent/config/renderer/switch';
import { dataValidateAndReport } from '@src/slide/domain/slide-app/utils/data-validate';

interface IPasteSdkHandlerServiceDelegates {
    uiDataService: IUiDataService;
    selectionService: ISelectionService;
    masterLayoutEditService: IMasterLayoutEditService;
    sectionManager: ISectionManager;
    addonManager?: IAddonManager;
}

export class PasteSdkHandler {
    private slideSdkDataModify: SlideSdkDataModify;
    private uiDataService?: IUiDataService;
    private selectionService?: ISelectionService;
    private masterLayoutEditService?: IMasterLayoutEditService;
    private sectionManager?: ISectionManager;
    private addonManager?: IAddonManager;

    public constructor(private storeManager: StoreManager) {
        this.slideSdkDataModify = new SlideSdkDataModify();
    }

    public setServiceDelegates(services: Partial<IPasteSdkHandlerServiceDelegates>) {
        this.uiDataService = this.uiDataService ?? services.uiDataService;
        this.selectionService = this.selectionService ?? services.selectionService;
        this.masterLayoutEditService = this.masterLayoutEditService ?? services.masterLayoutEditService;
        this.sectionManager = this.sectionManager ?? services.sectionManager;
        this.addonManager = this.addonManager ?? services.addonManager;
        this.slideSdkDataModify.setServiceDelegates(services);
    }

    public pasteSdkDataOmitTable(sdkData): void {
        let dataArray: ISdkData[] = [];
        let noteSlideArr: INoteSlideData[] = [];
        if (ENABLE_PASTE_SPECIAL) {
            dataArray = sdkData.data.map(allSdkData => allSdkData.ownSdkData);
            noteSlideArr = sdkData.noteList?.map(allSdkData => allSdkData.ownSdkData) || [];
        } else {
            dataArray = sdkData.data;
            noteSlideArr = dataArray.filter(sdkData => sdkData.type === DataType.Notes) as INoteSlideData[];
        }

        const isAddLayout = dataArray.every(sdkData => sdkData.type === DataType.SlideLayout);
        const slideArr = dataArray.filter(sdkData => sdkData.type === DataType.Slide);
        const isAddSlide = !!slideArr.length;
        const isAddSection = dataArray[0].type === DataType.Section;
        // 粘贴数据集中处理
        this.modifyCopySdkModel(sdkData);
        if (isAddLayout) {
            this.pasteSdkModelToAddLayout(dataArray, sdkData);
            this.storeManager.updateLastMouseDownRegion(RegionType.SLIDELIST);
        } else if (isAddSection) {
            this.pasteSdkModelToAddSection(dataArray, sdkData);
            this.storeManager.updateLastMouseDownRegion(RegionType.SLIDELIST);
        } else if (isAddSlide) {
            // 屏蔽母版编辑下粘贴幻灯片
            if (this.masterLayoutEditService?.isMasterEditType) return;
            let rawSlideIdToSlideDataModelMap = {};
            sdkTransaction(() => {
                rawSlideIdToSlideDataModelMap = this.pasteSdkModelToAddSlide(sdkData);
                // 添加相关联的备注页
                if (noteSlideArr.length && !isEmpty(rawSlideIdToSlideDataModelMap)) {
                    noteSlideArr.forEach((noteSlide: INoteSlideData)  => {
                        const slideDataModel = rawSlideIdToSlideDataModelMap?.[noteSlide.slideId];
                        slideDataModel?.api.addNoteSlide({ ...noteSlide, slideId: slideDataModel.id });
                    });
                }
            });
            CPUtils.selectLastAddSlide(
                this.storeManager.getInsertSlideIndex(),
                Object.keys(rawSlideIdToSlideDataModelMap).length,
                UIModelType.SLIDE,
            );
            this.storeManager.updateLastMouseDownRegion(RegionType.SLIDELIST);
        } else {
            this.pasteSdkModelToAddShape(sdkData);
            this.storeManager.updateLastMouseDownRegion(RegionType.EDITOR);
        }
        // this.printPastePerformance('adapt data');
    }

    private modifyCopySdkModel(sdkData) {
        if (ENABLE_PASTE_SPECIAL) {
            sdkData.data.forEach((data) => {
                [data.inheritedSdkData, data.ownSdkData].forEach((sdkData, sourceIndex) => {
                    const source = `paste_${sourceIndex === 0 ? 'inherited' : 'owned'}` as const;
                    dataValidateAndReport(sdkData, source, sdkData?.type);
                });
            });
            // 清理连接线头尾无效吸附
            this.clearInvalidConnectorPoints(sdkData.data.map(data => data.inheritedSdkData));
            this.clearInvalidConnectorPoints(sdkData.data.map(data => data.ownSdkData));
            // 控制点脏数据清理
            PasteSpecialUtils.modifyPrstGeomAdjName(sdkData.data.map(data => data.inheritedSdkData));
            PasteSpecialUtils.modifyPrstGeomAdjName(sdkData.data.map(data => data.ownSdkData));
            // 图片的 prst 必须存在
            PasteSpecialUtils.addPrstGeomInPicture(sdkData.data.map(data => data.inheritedSdkData));
            PasteSpecialUtils.addPrstGeomInPicture(sdkData.data.map(data => data.ownSdkData));
        } else {
            this.clearInvalidConnectorPoints(sdkData.data);
            PasteSpecialUtils.modifyPrstGeomAdjName(sdkData.data);
            PasteSpecialUtils.addPrstGeomInPicture(sdkData.data);
        }
    }

    /**
     * 遍历所有连接线，查看连接线头尾的吸附ID是否在此次粘贴的图形ID数组中，不在则说明无效，置空
     * @param {*} dataArray 粘贴数据
     */
    private clearInvalidConnectorPoints(dataArray: IDrawingShapeData[]) {
        // 粘贴的图形ID数组
        const shapeKeyArr = dataArray?.map(e => e?.id).filter(e => !!e);
        // 连接线数组
        const connectorArr = dataArray?.filter(e => e?.type === DataType.Connector);
        // 遍历所有连接线，查看连接线头尾的吸附ID是否在此次粘贴的图形ID数组中，不在则说明无效，置空
        connectorArr?.forEach((connectorItem) => {
            const stCxn = (connectorItem as IConnectorData).nvPr?.stCxn;
            const endCxn = (connectorItem as IConnectorData).nvPr?.endCxn;
            if (stCxn?.id && !shapeKeyArr.includes(stCxn.id)) {
                delete (connectorItem as IConnectorData).nvPr.stCxn;
            } else if (stCxn?.id && stCxn.idx === undefined) {
                // 补充 idx 默认值，否则导出会报修复
                stCxn.idx = 0;
            }
            if (endCxn?.id && !shapeKeyArr.includes(endCxn.id)) {
                delete (connectorItem as IConnectorData).nvPr.endCxn;
            } else if (endCxn?.id && endCxn.idx === undefined) {
                endCxn.idx = 0;
            }
        });
    }

    /**
     * 粘贴 sdkModel 数据用来添加图形
     * @param dataArray
     */
    private pasteSdkModelToAddShape(clipboardData: IClipboardData) {
        if (ENABLE_PASTE_SPECIAL) {
            this.pasteSpecialSdkModelToAddShape(clipboardData);
            return;
        }
        const dataArray = clipboardData.data;
        if (!dataArray.length) return;
        const newElementSdkData: IDrawingShapeData[] = [];
        const iframeCount = dataArray.filter(this.isIframeElementFromSdkData).length;
        const unableAddIframe = !this.addonManager?.canAddIframeElement(iframeCount);

        dataArray.forEach((sdkData) => {
            if (this.isIframeElementFromSdkData(sdkData) && unableAddIframe) {
                return;
            }
            // if (sdkData.type === ComponentsType.TABLE) {
            //     CPUtils.extractTblRangeData((sdkData instanceof BaseComponent && sdkData.data) || sdkData);
            // }
            // const newSdkData = createElementByType(sdkData);
            const newSdkData = deepClone(sdkData);
            ElementSdkDataModify.adjustElementPosition(newSdkData, this.selectionService?.currentSlide);
            newElementSdkData.push(newSdkData);
        });
        if (newElementSdkData.length) {
            ElementSdkDataModify.checkAndAdjustElementPosition(newElementSdkData);// 同时添加多个相同元素，位置有可能一样，这里处理一下
            // this.printPastePerformance('check position');
            mobxTransaction(() => {
                (this.selectionService?.currentSlide?.sdkData as SlideModelSdkTypeV3)
                    ?.api.addShapes(newElementSdkData);
                // this.printPastePerformance('add shapes');
                CPUtils.selectLastAddElement(newElementSdkData.length);
                // this.printPastePerformance('select element');
            });
        }
    }

    /**
     * 页内元素选择性粘贴
     * @param ICopiedShapeData[]
     */
    private pasteSpecialSdkModelToAddShape(clipboardData: IClipboardData) {
        const dataArray = clipboardData.data;
        if (!dataArray.length) return;
        const hasRemoveAttachment = PasteSpecialUtils.removeAttachment(clipboardData);
        if (hasRemoveAttachment) {
            CommonTips.getInstance().show({
                message: i18n.t('暂不支持跨文档粘贴附件'),
                commonTipsType: CommonTipsType.INFO,
                block: false,
                autoClose: true,
            });
        }
        const newSdkDataList: IDrawingShapeData[] = [];
        const dataList = cloneDeep(dataArray);
        const iframeCount = dataArray.filter(this.isIframeElementFromSdkData).length;
        const unableAddIframe = !this.addonManager?.canAddIframeElement(iframeCount);
        const currentSlideDataModel = this.selectionService?.currentSlide?.sdkData as ISlideDataModel;
        dataList.forEach((allSdkData) => {
            allSdkData.ownSdkData = PasteSpecialUtils.updatePlaceHolderData(
                allSdkData.ownSdkData as IShapeData,
                currentSlideDataModel,
            ) as ISdkData;
            Object.keys(allSdkData).forEach((key) => {
                if (this.isIframeElementFromSdkData(allSdkData[key]) && unableAddIframe) {
                    return;
                }
                ElementSdkDataModify.adjustElementPosition(allSdkData[key], this.selectionService?.currentSlide, key);
            });
            // @ts-ignore
            newSdkDataList.push(allSdkData.ownSdkData);
        });
        ElementSdkDataModify.checkAndAdjustElementPosition(newSdkDataList);// 同时添加多个相同元素，位置有可能一样，这里处理一下
        mobxTransaction(() => {
            PasteSpecialUtils.updateResourceMap({
                presentation: this.uiDataService?.presentation?.sdkData as PresentationDataModel,
                resourceMap: clipboardData.resourceMap as IResourceMapData,
                copiedDocId: clipboardData.globalPadId,
            });
            const [firstElementDataModel] = currentSlideDataModel?.api?.addShapes(newSdkDataList) || [];
            CPUtils.selectLastAddElement(newSdkDataList.length);
            if (clipboardData.sdkVersion === CopyDataVersion.Version3) {
                pasteSpecialEventBus.emit(PanelType.EDIT_PASTE_PANEL, {
                    clipboardData,
                    type: CopyElementType.SHAPE,
                    firstElementDataId: firstElementDataModel.id,
                });
            }
        });
    }

    private pasteSdkModelToAddLayout(dataArray: any, { globalPadId, slideSize }: any) {
        const newSlideSdkData = this.getNewSlideSdkData(dataArray, { globalPadId, slideSize });
        const layoutSdkType = DataType.SlideLayout;
        if (newSlideSdkData.length && dataArray.every(i => i.type === layoutSdkType)) {
            // 复制插入版式可详见 https://doc.weixin.qq.com/doc/w3_Ae4ADwbBAJspJaUHhEDQuW3ew4hCs?scode=AJEAIQdfAAosxts9CmAe4ADwbBAJs
            sdkTransaction(() => {
                const { selectionService } = this;
                if (!selectionService) {
                    return;
                }
                const { masterList, layoutList } = this.uiDataService?.presentation ?? {
                    masterList: [] as IMasterModel[],
                    layoutList: [],
                };
                const { currentSlide, currentSlideType } = selectionService;
                const insertIndex = this.getLayoutInsertIndex();
                const masterId = {
                    [UIModelType.MASTER]: masterList.findIndex(i => i.id === currentSlide?.id),
                    [UIModelType.LAYOUT]: masterList
                        .findIndex(i => i.id === (currentSlide as ILayoutModel)?.masterId),
                }[currentSlideType] ?? 0;
                newSlideSdkData.forEach((layout: ILayoutData) => {
                    const currentMasterId = masterList[masterId]?.id;
                    if (currentMasterId) {
                        layout.masterId = currentMasterId;
                    }
                });

                (this.uiDataService?.presentation.sdkData as PresentationModelSdkTypeV3)?.api
                    ?.addLayouts(newSlideSdkData as Array<ILayoutData>, insertIndex);
                const uiInsertIndex = MasterLayoutUtils.getUiIndexFromSdkIndex(
                    MasterLayoutUtils.getUiLayoutList(masterList),
                    layoutList,
                    insertIndex,
                ) ?? 0;
                this.afterAddSlides(uiInsertIndex, dataArray.length);
            });
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.MASTER,
                action: TDWActionType.THUMB_PASTE,
            });
        }
    }

    /**
     * 粘贴幻灯片
     */
    private pasteSdkModelToAddSlide(sdkData): Record<string, SlideDataModel> {
        if (ENABLE_PASTE_SPECIAL) {
            // 选择性粘贴 -新增逻辑
            return this.pasteSpecialSdkModelToAddSlide(sdkData as IClipboardData);
        }

        // 普通粘贴 - 原有逻辑
        const { data: dataArray, globalPadId, slideSize } = sdkData;
        const newSlideSdkData = this.getNewSlideSdkData(dataArray, { globalPadId, slideSize });
        if (!newSlideSdkData.length) return {};

        let rawSlideIdToSlideDataModelMap: Record<string, SlideDataModel> = {};
        const insertSlideIndex = this.storeManager.getInsertSlideIndex();
        const insertGapIndex = this.storeManager.getInsertGapIndex();
        sdkTransaction(() => {
            const slideArr = newSlideSdkData.map((slideSdkData: ISlideData) => {
                const cloneSlideSdkData = { ...slideSdkData };
                // 需要手动移除旧的 noteSlideId，否则会导致粘贴的备注页无法成功创建
                delete cloneSlideSdkData.noteSlideId;
                return cloneSlideSdkData;
            });
            const sdkDataV3 = this.uiDataService?.presentation.sdkData as PresentationModelSdkTypeV3;
            if (sdkDataV3?.sectionList?.length) {
                sdkDataV3?.api.addSlidesWithSection(slideArr as Array<ISlideData>, insertGapIndex);
            } else {
                sdkDataV3?.api.addSlides(slideArr as Array<ISlideData>, insertGapIndex);
            }
            // 建立原slideId与新slideDataModel的映射关系
            rawSlideIdToSlideDataModelMap = Object.fromEntries(newSlideSdkData
                .map(({ id }: ISlideData, i: number) => ([
                    id,
                    this.uiDataService?.presentation.sdkData?.slideList[insertSlideIndex + i] as SlideDataModel,
                ])));
        });
        this.sectionManager?.expandSelectedSection();
        return rawSlideIdToSlideDataModelMap;
    }

    /**
     * 粘贴幻灯片-选择性粘贴
     * 粘贴时默认使用目标主题，目标母版下的同名layoutName版式为目标版式，
     * 如果找不到同名目标版式，则需要在目标母版中创建新的版式
     * @param clipboardData 剪贴板的数据
     * @returns slideId与新slideDataModel的映射关系
     */
    private pasteSpecialSdkModelToAddSlide(clipboardData: IClipboardData): Record<string, SlideDataModel> {
        if (!clipboardData.data.length) return {};
        const hasRemoveAttachment = PasteSpecialUtils.removeAttachment(clipboardData);
        if (hasRemoveAttachment) {
            CommonTips.getInstance().show({
                message: i18n.t('暂不支持跨文档粘贴附件'),
                commonTipsType: CommonTipsType.INFO,
                block: false,
                autoClose: true,
            });
        }
        const sdkDataV3 = this.uiDataService?.presentation?.sdkData as IPresentationDataModel;
        let rawSlideIdToSlideDataModelMap: Record<string, SlideDataModel> = {};
        const insertSlideIndex = this.storeManager.getInsertSlideIndex();
        const insertGapIndex = this.storeManager.getInsertGapIndex();
        sdkTransaction(() => {
            if (!this.uiDataService) return {};
            const newSlideSdkDataList = PasteSpecialUtils.reorganizeSlideSdkData({
                clipboardData,
                insertSlideIndex: insertSlideIndex > 0 ? insertSlideIndex - 1 : insertSlideIndex,
                sdkDataV3,
                slideSdkDataModify: this.slideSdkDataModify,
                uiDataService: this.uiDataService,
            });
            if (!newSlideSdkDataList) return {};
            const ownList: ISlideData[] = newSlideSdkDataList.map(allSdkData => allSdkData.ownSdkData);
            // 粘贴时，更新文档的resourceMap
            PasteSpecialUtils.updateResourceMap({
                presentation: sdkDataV3 as PresentationDataModel,
                resourceMap: clipboardData.resourceMap as IResourceMapData,
                copiedDocId: clipboardData.globalPadId,
            });
            if (sdkDataV3?.sectionList?.length) {
                sdkDataV3?.api.addSlidesWithSection(ownList, insertGapIndex);
            } else {
                sdkDataV3?.api.addSlides(ownList, insertGapIndex);
            }
            Promise.resolve().then(() => {
                if (clipboardData.sdkVersion === CopyDataVersion.Version3) {
                    pasteSpecialEventBus.emit(PanelType.SLIDE_PASTE_PANEL,  {
                        clipboardData,
                        type: CopyElementType.SLIDE,
                        insertSlideIndex,
                        insertGapIndex,
                    });
                }
            });
            // 建立原slideId与新slideDataModel的映射关系
            rawSlideIdToSlideDataModelMap = Object.fromEntries(newSlideSdkDataList
                .map(({ ownSdkData }: ICopiedSlideData, i: number) => ([
                    ownSdkData.id,
                    this.uiDataService?.presentation?.sdkData?.slideList[insertSlideIndex + i] as SlideDataModel,
                ])));
        });

        this.sectionManager?.expandSelectedSection();
        return rawSlideIdToSlideDataModelMap;
    }

    private getNewSlideSdkData(dataArray: Array<IPageData>, { globalPadId, slideSize }): IPageData[] {
        const newSlideSdkData: IPageData[] = [];
        dataArray.forEach((sdkData) => {
            if (sdkData.type === DataType.Slide) {
                const newSDKData: ISlideData = deepClone(sdkData);
                if (SlideDataServices.DocInfoManager()?.globalPadId !== globalPadId) {
                    this.slideSdkDataModify.adjustPageData(newSDKData, slideSize);
                }
                newSlideSdkData.push(newSDKData);
            }
            // 复制的内容全是版式时，才可以粘贴版式内容
            if (dataArray.every(i => i.type === DataType.SlideLayout) && sdkData.type === DataType.SlideLayout) {
                const newSDKData: ILayoutData = deepClone(sdkData);
                newSlideSdkData.push(newSDKData);
            }
        });
        return newSlideSdkData;
    }

    private pasteSdkModelToAddSection(dataArray: any[], privateData: any) {
        const { sectionList } = this.uiDataService?.presentation ?? { sectionList: [] };
        if (!sectionList || sectionList.length === 0) {
            return;
        }
        const [sectionModel] = dataArray;
        const newSlideSdkData = this.getNewSlideSdkData(dataArray.slice(1), privateData);
        if (sectionModel && newSlideSdkData.length) {
            const insertIndex = this.storeManager.getInsertSlideIndex();
            const clearanceIndex = ClearanceUtils.calcClearanceIndexFromSlideIndex(insertIndex - 1, sectionList);
            sdkTransaction(() => {
                const sdk = this.uiDataService?.presentation.sdkData as PresentationModelSdkTypeV3;
                if (sdk?.sectionList?.length) {
                    sdk?.api.addSlidesWithSection(newSlideSdkData as Array<ISlideData>, clearanceIndex);
                } else {
                    sdk?.api.addSlides(newSlideSdkData as Array<ISlideData>, clearanceIndex);
                }
                sdk?.api.addSection(sectionModel.name, clearanceIndex);
            });
            CPUtils.selectLastAddSlide(insertIndex, newSlideSdkData.length);
        }
    }

    private afterAddSlides(insertIndex: number, addLength: number) {
        if (this.uiDataService?.presentation.hasSections()) {
            const sectionList = this.uiDataService.presentation.sectionList || [];
            let clearanceIndex = this.selectionService?.slideClearanceIndex;
            if (typeof clearanceIndex !== 'number' || clearanceIndex === -1) {
                const currentSlideIndex = this.selectionService?.currentSlideIndex ?? -1;
                const selectedSectionIndex = this.sectionManager?.selectedSectionIndex ?? -1;
                if (selectedSectionIndex !== -1) {
                    // 选中整个节，应粘贴到选中节的末尾
                    clearanceIndex = ClearanceUtils.calcClearanceIndexFromSectionIndex(
                        selectedSectionIndex,
                        sectionList,
                    ) + (sectionList[selectedSectionIndex]?.numSlides ?? 0);
                } else if (currentSlideIndex !== -1) {
                    clearanceIndex = ClearanceUtils.calcClearanceIndexFromSlideIndex(
                        currentSlideIndex,
                        sectionList,
                    );
                } else {
                    clearanceIndex = ClearanceUtils.calcClearanceIndexFromSlideIndex(
                        insertIndex,
                        sectionList,
                    );
                }
            }
            this.uiDataService.presentation
                .getSectionProperty()
                .insertSlideIntoCorrespondingSection(clearanceIndex, addLength);
        }
    }

    private getLayoutInsertIndex() {
        const { selectionService } = this;
        if (!selectionService) {
            return;
        }
        const { masterList, layoutList } = this.uiDataService?.presentation ?? {
            masterList: [],
            layoutList: [],
        };
        const { currentSlide, currentSlideType } = selectionService;
        const master = currentSlide?.getRelationMasterModel() as IMasterModel;
        const insertIndex =
            {
                [UIModelType.MASTER]: MasterLayoutUtils.getIndexFromMaster(
                    masterList,
                    layoutList,
                    currentSlide as IMasterModel,
                ),
                [UIModelType.LAYOUT]: MasterLayoutUtils.getIndexFromLayout(
                    master?.layoutList,
                    currentSlide as ILayoutModel,
                ),
            }[currentSlideType] ?? 0;
        return insertIndex;
    }

    private isIframeElementFromSdkData(sdkData) {
        return sdkData.type === DataType.Shape && (Number(sdkData?.nvPr?.addon?.displayMode) === STAddonMode?.iframe);
    }
}
